import { RequestOptions } from '@/types/Request'
import { request, ORIGIN } from '@/request/RequestWrapper'
import { queryStringBuilder } from '@/utils/util'

/**
 * 创建任务
 * @param loadingTarget 要显示 loading 的元素
 * @param parameters
 * @param requestOptions { RequestOptions } 请求选项
 */
// eslint-disable-next-line camelcase
function createTask (loadingTarget: HTMLElement | null, parameters: any, requestOptions: RequestOptions = {}) {
  const url = `${ORIGIN}/ConvertFastq/createTask`
  const options = {
    body: queryStringBuilder(arguments[1])
  }
  const messages = {
    error: 'fail to create task'
  }
  const params = { url, loadingTarget, messages, options, ...requestOptions }
  return request(params)
}

/**
 * 获取算法参数列表
 * @param loadingTarget 要显示 loading 的元素
 * @param requestOptions 请求选项
 */
function getAlgParamList (loadingTarget: HTMLElement | null, requestOptions: RequestOptions = {}) {
  const url = `${ORIGIN}/ConvertFastq/getAlgParamList`
  const options : RequestInit = {
    method: 'get'
  }
  const messages = {
    error: 'get data error'
  }
  const params = { url, loadingTarget, messages, options, ...requestOptions }
  return request(params)
}

export { createTask, getAlgParamList }
